import { createReducer, on } from '@ngrx/store';
import * as HistoryTicketActions from './ticket-history.actions';
import { TicketHistoryFilterState } from '../ticket-history.model';

export interface TicketHistoryState {
    filter: TicketHistoryFilterState;
}

export const TICKET_HISTORY_FEATURE_KEY = 'ticketHistory';

export const TICKET_HISTORY_INITIAL_STATE: TicketHistoryState = {
    filter: null
};

export const ticketHistoryReducer = createReducer(
    TICKET_HISTORY_INITIAL_STATE,
    on(HistoryTicketActions.updateTicketHistorySearchFilter, (state, { payload }) => {
        return { ...state, filter: { ...state.filter, ...payload } };
    })
);
